<template>
  <div class="section">
    <div class="l-section">
      <div class="row">
        <img class="icon" src="@/assets/image/security-icon1.png" />
        <div class="col">
          <div><span class="name">账户实名认证</span></div>
          <div class="label" style="color: #ff5c35">
            {{ details.status | status }}
          </div>
        </div>
      </div>
      <Button
        v-if="details.status !== 1"
        class="btn-height45"
        @click="showUpdateCertifiedModal"
        >认证</Button
      >
    </div>
    <div class="l-section">
      <div class="row">
        <img class="icon" src="@/assets/image/security-icon2.png" />
        <div class="col">
          <div>
            <span class="name">登录密码</span
            ><span style="color: #ff5c35; margin-left: 10px"
              >({{ details.hasPwd === 0 ? "未设置" : "已设置" }})</span
            >
          </div>
          <div class="label">有助于保护您的帐号安全</div>
        </div>
      </div>
      <Button class="btn-height45" @click="showUpdatePasswordModal"
        >修改</Button
      >
    </div>
    <div class="l-section">
      <div class="row">
        <img class="icon" src="@/assets/image/security-icon3.png" />
        <div class="col">
          <div><span class="name">账户邮箱</span></div>
          <div class="label" style="color: #ff5c35">
            {{ !details.e ? "未设置" : details.e }}
          </div>
        </div>
      </div>
      <Button class="btn-height45" @click="showEmail(!details.e)">{{
        !details.e ? "设置" : "修改"
      }}</Button>
    </div>
    <div class="l-section">
      <div class="row">
        <img class="icon" src="@/assets/image/security-icon4.png" />
        <div class="col">
          <div>
            <span class="name">绑定手机</span
            ><span style="color: #ff5c35; margin-left: 10px"
              >({{ !details.phone ? "未绑定" : "已绑定" }})</span
            >
          </div>
          <div class="label">{{ details.phone }}</div>
        </div>
      </div>
      <Button class="btn-height45" @click="updatePhone">修改</Button>
    </div>
    <updateCertifiedModal
      :show.sync="updateCertifiedModalVisibility"
      @submit-success="onSuccess"
    ></updateCertifiedModal>
    <updatePasswordModal
      :show.sync="updatePasswordModalVisibility"
      @submit-success="onSuccess2"
    ></updatePasswordModal>
    <addEmailModal
      :show.sync="addEmailModalVisibility"
      @submit-success="onSuccess"
    ></addEmailModal>
    <updateEmailModal
      :show.sync="updateEmailModalVisibility"
      ref="updateEmailModal"
      @submit-success="onSuccess"
    ></updateEmailModal>
    <updatePhoneModal
      ref="updatePhoneModal"
      :show.sync="updatePhoneModalVisibility"
      @submit-success="onSuccess"
    ></updatePhoneModal>
  </div>
</template>

<script>
import { securityCenter } from "api/customer.js";
import updateCertifiedModal from "components/account/updateCertifiedModal.vue";
import updatePasswordModal from "components/account/updatePasswordModal.vue";
import addEmailModal from "components/account/addEmailModal.vue";
import updateEmailModal from "components/account/updateEmailModal.vue";
import updatePhoneModal from "components/account/updatePhoneModal.vue";

export default {
  name: "security",
  components: {
    updateCertifiedModal,
    updatePasswordModal,
    addEmailModal,
    updateEmailModal,
    updatePhoneModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case -1:
          title = "未认证";
          break;
        case 0:
          title = "认证中";
          break;
        case 1:
          title = "认证成功";
          break;
        case 2:
          title = "认证失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      details: {
        sfz: "",
        status: 0,
        e: "",
        hasPwd: 0,
        phone: "",
      },
      updateCertifiedModalVisibility: false,
      updatePasswordModalVisibility: false,
      addEmailModalVisibility: false,
      updateEmailModalVisibility: false,
      updatePhoneModalVisibility: false,
    };
  },
  created() {
    this.req_getInfo();
  },
  methods: {
    async req_getInfo() {
      try {
        const { code, data } = await securityCenter();
        if (code === 200) {
          this.details = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onSuccess(callback) {
      await this.req_getInfo();
      callback(true);
    },
    onSuccess2(callback) {
      callback(true);
    },
    showUpdateCertifiedModal() {
      this.updateCertifiedModalVisibility = true;
    },
    showUpdatePasswordModal() {
      this.updatePasswordModalVisibility = true;
    },
    showEmail(val) {
      this.updateEmailModalVisibility = true;
      this.$refs.updateEmailModal.onShow()
    },
    updatePhone() {
      this.updatePhoneModalVisibility = true;
      this.$refs.updatePhoneModal.onShow()
    },
  },
};
</script>

<style lang="less" scoped>
.section {
  background-color: #fff;
  border-radius: 8px;
  padding: 50px;
}
.l-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 0;
  border-bottom: 1px solid #eaeaea;
  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon {
      width: 50px;
      height: 50px;
    }
    .col {
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        color: #333333;
        font-weight: bold;
        font-size: 18px;
      }
      .label {
        color: #999999;
      }
    }
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
